var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocx64 = function SvgDocx64(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 2048 2048"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1536 1248v64h-480v-64m480-160v64h-480v-64m480-160v64h-480v-64m480-160v64h-480v-64m663-224q9 11 9 23v1321q0 14-9 23t-23 9H384q-14 0-23-9t-9-23v-416H200q-30 0-51-21t-21-51V680q0-30 21-51t51-21h152V160q0-14 9-23t23-9h905q14 0 23 9m0 407h361l-361-361m384 393h-384q-14 0-23-9t-9-23V160H384v448h536q30 0 51 21t21 51v720q0 30-21 51t-51 21H384v416h1312M423 1160q-1-8-2-15t-2-12l-68-327h-91l111 468h105l71-309q1-4 3-13 1-10 3-20 1-11 3-20t3-14q1 4 3 13 1 8 3 18 1 10 3 20 1 9 3 15l75 310h104l110-468h-89l-63 324q-6 34-9 58-2-18-4-33-3-15-6-27l-78-322h-98l-76 327q-2 11-5 28-4 17-6 28 0-12-3-29",
    className: "docx_64_svg__OfficeIconColors_HighContrast"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    d: "M384 1904q-16 0-16-16V160q0-16 16-16h905q7 0 12 5l406 406q5 5 5 12v1321q0 16-16 16z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#797774",
    d: "M1719 544q9 11 9 23v1321q0 14-9 23t-23 9H384q-14 0-23-9t-9-23V160q0-14 9-23t23-9h905q14 0 23 9m0 407h361l-361-361m384 393h-384q-14 0-23-9t-9-23V160H384v1728h1312z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#41A5EE",
    d: "M1536 768v64h-480v-64z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B7CD3",
    d: "M1536 928v64h-480v-64z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#185ABD",
    d: "M1536 1088v64h-480v-64z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#103F91",
    d: "M1536 1248v64h-480v-64z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#185ABD",
    d: "M920 1472H200q-30 0-51-21t-21-51V680q0-30 21-51t51-21h720q30 0 51 21t21 51v720q0 30-21 51t-51 21"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M423 1160q3 17 3 29 2-11 6-28 3-17 5-28l76-327h98l78 322q3 12 6 27 2 15 4 33 3-24 9-58l63-324h89l-110 468H646l-75-310q-2-6-3-15-2-10-3-20-2-10-3-18-2-9-3-13-1 5-3 14t-3 20q-2 10-3 20-2 9-3 13l-71 309H371L260 806h91l68 327q1 5 2 12t2 15"
  })));
};
export default SvgDocx64;